/*
 * Labels and colour roles for the shared connection-status indicator.
 * Used by ConnectionStatus to distinguish live, connecting and disconnected transport states.
 * Includes the sharing mode so a shared connection is described consistently with a direct one.
 * Example: const statusInfo = connectionInfo(status, sharingMode);
 */

const STATES = {
  initializing: { color: 'text-disabled', pulse: false, message: null },
  connected: { color: 'text-disabled', pulse: false, message: null },
  unauthenticated: { color: 'text-disabled', pulse: false, message: null },
  streaming: { color: 'conn-status-ok', pulse: false, message: null },
  catching_up: { color: 'conn-status-ok', pulse: true, message: null },

  reconnecting: {
    color: 'conn-status-bad',
    pulse: true,
    message: 'Connection lost — attempting to reconnect.'
  },

  offline: { color: 'conn-status-bad', pulse: true, message: 'You appear to be offline.' },

  expired: {
    color: 'conn-status-bad',
    pulse: false,
    message: 'Session expired — please refresh the page.'
  }
};

export function connectionInfo(status, mode) {
  const info = { ...(STATES[status] || STATES.initializing) };
  if (status === 'streaming' || status === 'catching_up') {
    info.color =
      mode === 'shared'
        ? 'conn-status-ok'
        : mode === 'per_page'
          ? 'conn-status-per-page'
          : 'text-disabled';
    info.message =
      mode === 'shared'
        ? 'Connected — shared across tabs.'
        : mode === 'per_page'
          ? 'Connected — this tab only.'
          : null;
  }
  return info;
}
